import React from "react";
import "./HoneymoonTrip.css";
import MaldivesRomanticEscape from "../../assets/MaldivesRomanticEscape.png";
import ParisLoveJourney from "../../assets/ParisLoveJourney.png";
import BaliBlissRetreat from "../../assets/BaliBlissRetreat.png";
import SantoriniSunsetRomance from "../../assets/SantoriniSunsetRomance.png";
import SwissAlpineGetaway from "../../assets/SwissAlpineGetaway.png";
import HawaiiIslandRomance from "../../assets/HawaiiIslandRomance.png";
import { useNavigate } from "react-router-dom";
const honeymoonTrips = [
  {
    title: "Maldives Romantic Escape",
    image: MaldivesRomanticEscape,
    description:
      "Celebrate your love in the Maldives with crystal clear waters, luxurious overwater villas, and private candlelight dinners by the beach. Enjoy peaceful sunsets, snorkeling adventures, and relaxing spa experiences together in a breathtaking tropical paradise.",
    link: "/tour-package-data",
  },
  {
    title: "Paris Love Journey",
    image: ParisLoveJourney,
    description:
      "Explore the romantic streets of Paris filled with charming cafes, iconic landmarks, and beautiful river cruises. Stroll hand in hand, enjoy gourmet cuisine, and admire stunning city views while creating unforgettable memories together.",
    link: "/tour-package-data",
  },
  {
    title: "Bali Bliss Retreat",
    image: BaliBlissRetreat,
    description:
      "Experience a magical honeymoon in Bali surrounded by lush greenery, serene beaches, and private pool villas. Relax with couples spa treatments, watch breathtaking sunsets, and explore cultural temples for a perfect romantic escape.",
    link: "/tour-package-data",
  },
  {
    title: "Santorini Sunset Romance",
    image: SantoriniSunsetRomance,
    description:
      "Witness stunning sunsets over whitewashed cliffs in Santorini while enjoying peaceful seaside views. Stay in luxurious suites, savor Mediterranean cuisine, and capture romantic moments in one of the world’s most beautiful island destinations.",
    link: "/tour-package-data",
  },
  {
    title: "Swiss Alpine Getaway",
    image: SwissAlpineGetaway,
    description:
      "Escape to the Swiss Alps for breathtaking mountain views, cozy chalets, and scenic train journeys. Enjoy snowy landscapes, peaceful lakes, and intimate dinners by the fireplace for a charming and unforgettable honeymoon.",
    link: "/tour-package-data",
  },
  {
    title: "Hawaii Island Romance",
    image: HawaiiIslandRomance,
    description:
      "Immerse yourselves in Hawaii’s tropical beauty with golden beaches, scenic waterfalls, and vibrant island traditions. Surf gentle waves, enjoy sunset cruises, and relax under palm trees while celebrating your love in paradise.",
    link: "/tour-package-data",
  },
];

const HoneymoonTrip = () => {
  const navigate=useNavigate()
  return (
    <div className="honeymoon-container">
      <h2 className="honeymoon-title">Honeymoon Trip Packages</h2>

      <div className="honeymoon-grid">
        {honeymoonTrips.map((trip, index) => (
          <div
            className="honeymoon-card"
            key={index}
            onClick={() =>
              navigate(trip.link, {
                state: { title: trip.title },
              })
            }
          >
            <img src={trip.image} alt={trip.title} />
            <div className="honeymoon-content">
              <h3>{trip.title}</h3>
              <p>{trip.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HoneymoonTrip;
